<app-portal-collapsible
    title="Versicherte Instrumente"
    icon="instrument"
>
    <p class="fs:s fw:semibold">Mit dieser Versicherung sind die folgenden Instrumente versichert:</p>
    <dl class="grid-container vertical-gutter-lg">
        @for (item of pool; track item; let i = $index) {
            <app-portal-widget-details
                class="g-12"
                heading="{{ i + 1 }}. Instrument"
                detail="{{ item.ObjectDetail }} ({{ item.ObjectDescription }})"
            />
        }
    </dl>
</app-portal-collapsible>
